import { GenericObjectType } from "@rjsf/utils";

import { getRanaWidgetFromProperty } from "@/features/project-process-run-form";

import { FeatureSelectorFieldProps } from "../types/feature-selector-field-props-type";

const getSourceData = (allFormData: GenericObjectType, source: string) => {
  const sourcePath = source.split(".");
  let current: GenericObjectType | GenericObjectType[string] = allFormData;
  for (const key of sourcePath) {
    if (current && typeof current === "object" && key in current) {
      current = current[key];
    } else {
      return undefined;
    }
  }
  return current;
};

type FileType =
  | {
      type: "standard";
      path: string;
    }
  | {
      type: "own";
      id: string;
    }
  | null;

export function useSelectedFile(props: FeatureSelectorFieldProps): FileType {
  const { schema } = props;
  const allFormData = props.formContext?.allFormData;
  const standardBoundaryPaths = getRanaWidgetFromProperty(
    schema,
    "file_feature_selector"
  )?.standard_boundary_paths;

  const source = getRanaWidgetFromProperty(schema, "file_feature_selector")?.source;
  if (!source || !allFormData) return null;

  // Support nested source paths like "area.boundary"
  const sourceData = getSourceData(allFormData, source);

  if (!sourceData) {
    return null;
  }

  const selectedBoundaryPath =
    standardBoundaryPaths && typeof sourceData === "string" && standardBoundaryPaths[sourceData];
  const sourceFileId: string | undefined = sourceData.id;

  if (selectedBoundaryPath) {
    return { type: "standard", path: selectedBoundaryPath };
  } else if (sourceFileId) {
    return { type: "own", id: sourceFileId };
  }

  return null;
}
